import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import {
	FreepikFullImage,
	FreepikSearchImageData,
	HttpResponse,
} from '@/interfaces';

class Freepik {
	constructor(private client: AxiosInstance) {}

	async getSearchImages(
		term: string,
		limit: number,
		page: number,
		filterLandspace?: boolean
	): Promise<HttpResponse<FreepikSearchImageData>> {
		const params = [];
		params.push(`limit=${limit}`);
		params.push(`page=${page}`);
		filterLandspace &&
			params.push(`filters%255Borientation%255D%255Blandscape%255D=true`);
		const paramString = params.join('&');
		return this.client.get(`/marketing/search?term=${term}&${paramString}`);
	}

	async getFullFreepikImage(
		id: number
	): Promise<HttpResponse<FreepikFullImage>> {
		return this.client.get(`/marketing/${id}`);
	}
}

export const freepikService = new Freepik(axiosClient);
